const JWT_PATTERN = /eyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]*/g;
const BEARER_PATTERN = /Bearer\s+[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]*/gi;
const SENSITIVE_HEADERS = ['authorization', 'x-api-key', 'cookie', 'set-cookie'];

export function redactString(value: string): string {
  return value.replace(BEARER_PATTERN, 'Bearer [REDACTED-JWT]').replace(JWT_PATTERN, '[REDACTED-JWT]');
}

export function redactHeaders(headers: Record<string, any> | undefined): Record<string, any> | undefined {
  if (!headers) return headers;
  const cleaned = { ...headers };
  for (const key of Object.keys(cleaned)) {
    if (SENSITIVE_HEADERS.includes(key.toLowerCase())) {
      cleaned[key] = '[REDACTED]';
    } else if (typeof cleaned[key] === 'string') {
      cleaned[key] = redactString(cleaned[key]);
    }
  }
  return cleaned;
}

export function sanitizeErrorForTelemetry(error: any): Error {
  if (!error) return new Error('Unknown error');
  
  try {
    // Build a safe error message from the Axios error
    const status = error?.response?.status || error?.status || 'unknown';
    const statusText = error?.response?.statusText || error?.statusText || '';
    const url = error?.config?.url || error?.response?.config?.url || 'unknown';
    const message = error?.message || `Request failed with status ${status}`;
    
    const safeMessage = redactString(`${message} | Status: ${status} ${statusText} | URL: ${url}`);
    return new Error(safeMessage);
  } catch {
    return new Error('Error occurred (details redacted for security)');
  }
}

export function sanitizeExceptionProperties(err: any): Record<string, any> {
  const props: Record<string, any> = {};
  if (err?.response) {
    props.status = err.response.status;
    props.statusText = err.response.statusText;
    props.url = err?.config?.url || 'unknown';
    if (typeof err.response.data === 'string') {
      props.responseData = redactString(err.response.data);
    }
  } else if (err?.status) {
    props.status = err.status;
    props.statusText = err.statusText;
  }
  return props;
}
